ready(function(){
	const toggleDatesBtn = document.getElementById('toggleDates');
	if (toggleDatesBtn) {
		toggleDatesBtn.addEventListener('click' , function(e){
			this.getElementsByClassName('show_more')[0].classList.toggle('hidden');
			this.getElementsByClassName('show_less')[0].classList.toggle('hidden');
			const hiddenDates = this.previousElementSibling.getElementsByClassName('hiddenDate');
			Array.from(hiddenDates).forEach((item) => {
			   item.classList.toggle('!hidden');
			});
		});
	}
});